import { z } from "zod";

const urlSchema = z
  .string()
  .transform((url) => {
    if (!url) return null;
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    return `https://${url}`;
  })
  .refine((url) => {
    if (!url) return true;
    try {
      const parsedUrl = new URL(url);
      const hostnameParts = parsedUrl.hostname.split(".");
      return hostnameParts.length >= 2 && hostnameParts.every((x) => x.length > 0);
    } catch (e) {
      return false;
    }
  }, "Invalid URL");

export default urlSchema;
